const pattern = /(?:(?:https|http):)?\/\/fonts\.googleapis\.com\/[^'"\s]+/;
export default pattern;